import { IActVM } from '@/page-interface';
import { getContext } from 'svelte';

export const useActVm: () => IActVM = () => getContext('actVm') as IActVM;
